import styled, { css } from "styled-components";
import media from "@pagepro-monorepo/ui/lib/theme/config/media";
import { FlexBox } from "@pagepro-monorepo/ui/lib/components/styles/Grid";

import { StyledHeroContentProps } from "./types";

export const Figure = styled.figure`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 34.25rem;

  @media ${media.mobile} {
    height: 51rem;
  }

  @media ${media.tablet} {
    height: initial;
    bottom: 0;
  }
`;

export const Content = styled.div<StyledHeroContentProps>`
  z-index: 1;

  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `}

  @media ${media.tablet} {
    max-width: 37rem;
  }
`;

export const FormWrapper = styled(FlexBox)`
  @media ${media.tablet} {
    justify-content: flex-end;
  }
`;

export const Form = styled.div`
  margin: 0 -1.25rem;

  @media ${media.mobile} {
    margin: 0;
  }

  @media ${media.tablet} {
    max-width: 25.625rem;
    height: 37.5rem;
  }
`;

export const Title = styled.div`
  margin-bottom: 3rem;

  h1 {
    @media ${media.mobile} {
      font-size: 2.25rem;
    }

    @media ${media.tablet} {
      font-size: 4rem;
    }
  }
`;

export const Description = styled.div`
  margin-bottom: 3rem;

  @media ${media.tablet} {
    margin-bottom: 5.5rem;
  }
`;

export const Breadcrumbs = styled.nav`
  margin-bottom: 0.75rem;

  @media ${media.tablet} {
    margin-bottom: 2.5rem;
  }

  ul {
    display: flex;
    text-transform: uppercase;
  }

  a:hover {
    text-decoration: underline;
    text-underline-offset: 0.5rem;
  }

  li:not(:first-child)::before {
    content: "•";
    color: white;
    margin: 0 1rem;
  }

  span {
    color: red;
  }
`;
